import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


import "swiper/css";
import "swiper/css/autoplay";


const container = document.querySelector('[data-section-type="videos"]');
const sliderWrapper = container.querySelector(".videos__slider");

const slidesPerView = container.dataset.slidesPerView;

Fancybox.bind("[data-fancybox]");

const slider = new Swiper(sliderWrapper, {
    slidesPerView: 1,
    spaceBetween: 12,
    autoplay: true,
    loop: false,
    pagination: {
    el: '.swiper-pagination',
    clickable: true
    },
    breakpoints: {
    479: {
        spaceBetween: 16,
        slidesPerView: 2
    },
    767: {
        spaceBetween: 16,
        slidesPerView: 3
    },
    1024: {
        slidesPerView: slidesPerView
    }
    }
});

if (sliderWrapper.querySelector('.swiper-pagination-bullet') && sliderWrapper.querySelector('.swiper-pagination-bullet').length < 2) {
    sliderWrapper.querySelector('.swiper-pagination').hide();
}
